<template>
  <div>
    <div class="grid">
      <img
        style="grid-area: img"
        class="container w-18 h-18 object-cover"
        :src="$firstImage(data.product.images, 'small')"
        alt=""
        :onerror="defaultUrl"
      />
      <p class="font-bold text-base" style="grid-area: name">
        {{ data.product.name }}
      </p>
      <p class="space-x-3" style="grid-area: detail">
        <!-- <span>20枝/扎</span>
        <span>A极</span> -->
        <span>{{ data.product.attribute_text }}</span>
      </p>
      <p class="space-x-3" style="grid-area: length">
        <!-- <span>中熟</span>
        <span>50cm</span>
        <span>黄色</span> -->
      </p>
      <p
        class="text-red-500 justify-self-end text-base space-x-3px"
        style="grid-area: dollar"
      >
        <span>{{ $p(data.product.price) }}</span>
        <span>x</span>
        <span>{{ data.quantity }}</span>
      </p>
      <p class="justify-self-end !text-base">
        <el-link
          type="info"
          :underline="false"
          style="grid-area: delete"
          @click="$emit('del-cart', data.product.id)"
        >
          {{ $t("删除") }}
        </el-link>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: { data: Object },
  setup() {
    const defaultUrl =
      'this.src="' + require("@/assets/image/透明logo.png") + '"';

    return { defaultUrl };
  },
};
</script>

<style scoped lang="scss">
@import "@/style/stl.scss";
.grid {
  font-size: 0.875rem;
  display: grid;
  gap: 0.1rem 1rem;
  grid-template-columns: 4rem 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-areas:
    "img name dollar"
    "img detail delete"
    "img length .";
  justify-items: flex-start;
  align-items: center;
  margin-right: 1.5rem;
}
</style>
